import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { easyCollectAPI } from "../../services/api"
import { EasyCollect } from "../easy_collect";
import PartialPayment from "../partial_payment"
import SmartPayError from "../error"
import { HeaderComponent } from "../../shared_components";
import { Card, Skeleton } from "antd";

const isMobile = window.innerWidth <= 810;

const EasyCollectCardComponent = (props) => {
    const { isLoading, CoverComponent } = props
    return (
        <div className={isMobile ? "mobile-main-section" : "main-section"}>
            <Card variant="borderless" cover={<CoverComponent />} className={isMobile ? "mobile-wrapper" : "easycollect-card"}>
                <Skeleton loading={isLoading} paragraph={{ rows: 20 }}>
                    {props.children}
                </Skeleton>
            </Card>
        </div>
    )
}

const BaseWrapper = () => {
    const { url } = useParams();
    const [linkData, setlinkData] = useState({})
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => getLinkDetails(), [])

    const getLinkDetails = async () => {
        setIsLoading(true);
        await easyCollectAPI.get_link_details(url)
            .then((response) => {
                if (response && Object.keys(response).length > 0)
                    if (response.data && Object.keys(response.data).length > 0)
                        setlinkData(response.data)
                    else
                        setlinkData({ ...response })
                else setlinkData({})
            })
            .catch(() => setlinkData({}))
            .finally(() => setIsLoading(false))
    }

    if (isLoading) { return <EasyCollectCardComponent isLoading={isLoading} CoverComponent={() => <HeaderComponent logo={''} name={''} />} /> }
    let payment_type = linkData?.payment_type
    let mappedComponents = { 'SP': EasyCollect, "PP": PartialPayment }
    if (payment_type && Object.keys(mappedComponents).includes(payment_type)) {
        let FinalComponent = mappedComponents[payment_type]
        return <FinalComponent propsLinkData={linkData} />
    }
    let error_message = linkData && (linkData?.error || linkData?.err_msg)
    if (error_message) return <SmartPayError status="403" title={error_message} errorMsg="Please contact easebuzz support." />
    return <SmartPayError />
}
export default BaseWrapper